import { handleActions } from 'redux-actions';
import { removeDuplicates } from 'utils/array';

import reducersUtils from 'state/utils';

import actions from 'state/direct-order-recurring/days/actionCreators';

import initialState from 'state/direct-order-recurring/days/initial.state';

const days = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setDay]: (state, { payload: { day } }) => {
      if (state.indexOf(day) < 0) return removeDuplicates([...state, day]);
      return [...state.filter((dayKey) => dayKey !== day)];
    },
  },
  initialState
);

export default days;
